import { createAction, handleActions } from 'redux-actions';
import { call, put, takeLeading, select } from 'redux-saga/effects';
import { requestTermSearch } from 'modules/fetch/api';

const TERM_SEARCH_GET = 'termSearch/TERM_SEARCH_GET';
const TERM_PAGE_ARR_GET = 'termSearch/TERM_PAGE_ARR_GET';

export const termSearch = createAction(TERM_SEARCH_GET);
export const termPageArr = createAction(TERM_PAGE_ARR_GET);

const initialize = {
  termSearchList: [],
  pageArrList:[]
};

export function* getTermSearchList() {
  try {
    const result = yield call(requestTermSearch);

    yield put({ type: TERM_SEARCH_GET, payload: result.data });
  } catch (err) {
    console.log(`consoleMessage:::${err.message}`);
  }
}


export function* getTermArrList(action) {
  try {
    // console.log("action.payload", action.payload);
    const listLength = action.payload;
    // const termList = yield select(state => state.termSearchList.termSearchList);
    if(listLength) {
      const tempArr = [];
      for (let index = 0; index < listLength; index+1) {
        tempArr.push(index + 1);
      }
      yield put({ type: TERM_PAGE_ARR_GET, payload: tempArr });
    }
  } catch (err) {
    console.log(`consoleMessage:::${err.message}`);
  }
}


export function* termSearchSaga() {
  yield takeLeading(TERM_SEARCH_GET, getTermSearchList);
}

export function* termPageSaga() {
  yield takeLeading(TERM_PAGE_ARR_GET, getTermArrList);
}


export default handleActions(
  {
    [TERM_SEARCH_GET]: (state, { payload: termSearchList }) => {
      return { ...state, termSearchList };
    },
    [TERM_PAGE_ARR_GET]: (state, { payload: pageArrList }) => {
      return { ...state, pageArrList };
    },
  },
  initialize
);
